import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Button, MenuItem, Typography } from "@mui/material";

import { capitalize } from "../../utils/capitalize";

import FormikSelect from "../Form/FormikSelect";
import useParkingContainer from "../../containers/Parking/useParkingContainer";
import { useContent } from "../../content/useContent";

type IProps = {
  formik: any;
  setOpen: any;
  open: any;

  itemName: any;
};
const classes = {
  root: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    width: "50%",
    minWidth: "300px",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",

    boxShadow: 24,
    p: 4,
    "&:focus-visible": {
      outline: "none",
    },
  },
};
const ParkingModal: React.FC<IProps> = ({
  formik,
  setOpen,
  open,
  itemName,
}) => {
  const { general, pages } = useContent();
  const { parkings } = useParkingContainer();
  const { directories } = pages;

  const parkingZonesWithArea = parkings.reduce((result: any[], area: any) => {
    const zonesWithArea = area.zones.map((zone: any) => ({
      ...zone,
      area: area.title,
    }));
    return [...result, ...zonesWithArea];
  }, []);

  return (
    <div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={classes.root}>
            <Typography variant="h5" color="primary" component="h5">
              {`${general.addNew} ${capitalize(itemName)}`}
            </Typography>

            <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
              <FormikSelect
                formik={formik}
                name="parking"
                label={directories.parkingZone}
              >
                {parkingZonesWithArea.map((parkingZone: any) => (
                    <MenuItem key={parkingZone.id} value={parkingZone.id}>
                      {`${parkingZone.area} - ${parkingZone.designator} (${parkingZone.title})`}
                    </MenuItem>
                  ))}
              </FormikSelect>

              <Button
                onClick={formik.handleSubmit}
                variant="contained"
                sx={{ width: "100%", py: 1, mt: 2 }}
              >
                {`${general.addNew} ${capitalize(itemName)}`}
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default ParkingModal;
